import * as tslib_1 from "tslib";
import initializeSignatureContent from '../actions/initializeSignatureContent';
import store from '../store/store';
import { getFallbackValueIfNull } from 'owa-options-core';
import { OptionsCheckbox, OptionDescription } from 'owa-options-controls';
import { getUserConfiguration } from 'owa-session-store';
import strings from 'owa-strings/owa-options-strings';
import * as React from 'react';
import { reactive } from 'satcheljs/lib/legacy/react';
import SignatureEditor from './SignatureEditor';
import toggleSignatureSetting from '../actions/toggleSignatureSetting';
var SignatureFull = /** @class */ (function (_super) {
    tslib_1.__extends(SignatureFull, _super);
    function SignatureFull() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SignatureFull.prototype.componentDidMount = function () {
        initializeSignatureContent();
    };
    SignatureFull.prototype.render = function () {
        var _a = this.props, optionStore = _a.optionStore, userOptions = _a.userOptions;
        return (React.createElement("div", null,
            React.createElement(OptionDescription, null, strings.options_signature_title),
            React.createElement(SignatureEditor, null),
            React.createElement(OptionsCheckbox, { label: strings.options_signature_signNewMails, checked: getFallbackValueIfNull(optionStore.signNewMails, userOptions.AutoAddSignature), onChange: this.onSignNewEmailsClicked }),
            React.createElement(OptionsCheckbox, { label: strings.options_signature_signReplies, checked: getFallbackValueIfNull(optionStore.signReplies, userOptions.AutoAddSignatureOnReply), onChange: this.onSignRepliesClicked })));
    };
    SignatureFull.prototype.onSignNewEmailsClicked = function (ev, checked) {
        toggleSignatureSetting('signNewMails', checked);
    };
    SignatureFull.prototype.onSignRepliesClicked = function (ev, checked) {
        toggleSignatureSetting('signReplies', checked);
    };
    SignatureFull = tslib_1.__decorate([
        reactive({
            optionStore: function () { return store; },
            userOptions: function () { return getUserConfiguration().UserOptions; },
        })
    ], SignatureFull);
    return SignatureFull;
}(React.Component));
export default SignatureFull;
//# sourceMappingURL=SignatureFull.js.map